/*
 * @Author: fuRan NgeKaworu@gmail.com
 * @Date: 2022-09-07 18:51:31
 * @LastEditors: furan NgeKaworu@gmail.com
 * @LastEditTime: 2025-05-26 15:06:56
 * @FilePath: /newwork-h5/src/views/visitor/service/index.js
 * @Description:
 *
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved.
 */
import request from '@/utils/request'
import { LocaleMgr } from 'i18n'
const API_GATEWAY = process.env.VUE_APP_API_GATEWAY_URL
const APP = `${API_GATEWAY}/app` // 9097 端口
const DEPRECATED_BASE_URL_MANAGEMENT = `${API_GATEWAY}/managent`
const WORK = `${API_GATEWAY}/work` // 9099 端口
const MANAGEMENT = `${API_GATEWAY}/managent` // 9096 端口

// const WORK = APP
// const MANAGEMENT = APP

// 企业编码查询企业信息
export async function getCompanyInfo(companyCode) {
  const res = await request(WORK + `/new_work/company/query/code/${companyCode}`, {
    method: 'GET',
  })
  {
    const enterpriseLanguage = res?.enterpriseLanguage
    enterpriseLanguage && localStorage.setItem('enterpriseLanguage', enterpriseLanguage)
    await LocaleMgr.singleton.init({ company: res.id })
  }
  return res
}

//邀约信息查看 - 不加密
export function getVisit(data) {
  return request(MANAGEMENT + `/visit/get`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

//邀约信息查看 - 加密
export function getVisitFree(data) {
  return request(APP + `/visit/publicGet`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// 邀约地址查询
export function fetchVisitAddress(companyId) {
  return request(WORK + `/visitaddress/getByCid/?companyId=${companyId}`, {
    method: 'GET',
  })
}

//图片上传
export function upload(data) {
  return request(DEPRECATED_BASE_URL_MANAGEMENT + '/plat/files/uploadRemote', {
    method: 'POST',
    data,
  })
}

//邀约信息保存
export function visitorSave(data) {
  return request(MANAGEMENT + `/visit/save`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

//邀约信息保存 - 加密
export function visitorSaveEncrypt(data) {
  return request(WORK + `/external/visit/saveExterByHlg`, {
    method: 'POST',
    data,
  })
}
